import Vue from 'vue'
import VueRouter from 'vue-router'
import { appFont } from '@/utils/app-font'
import { webAuth, saveWebSession } from '@/utils/web-auth'
import { platformFromQuery, isWebAppQuery, isWebEntry } from '@/utils/web-auth-rules'
import { checkWebSession } from '@/utils/request'
import { webEntries, webPageTitle } from '@/utils/web-navigation'
// import Ylsfj from '../views/Ylsfj2'
// import Ylsfj2 from '../views/Ylsfj3'

Vue.use(VueRouter)

const routes = [
  { path: '/web/manage', component: () => import('../views/web/Management.vue') },
  { path: '/web/settings', component: () => import('../views/web/Settings.vue') },
  { path: '/', redirect: '/web/home' },
  { path: '/login', name: 'webLogin', component: () => import('../views/web/Login.vue') },
  { path: '/web/home', name: 'webHome', component: () => import('../views/web/Home.vue') },
  { path: '/develop', name: 'develop', component: () => import('../views/Develop.vue') },
  { path: '/expertDecision', name: 'expertDecision', component: () => import('../views/ExpertDecision.vue') },

  // 轮灌计划：/irrigationPlans（界面正在开发中）
  { path: '/irrigationPlans', name: 'irrigationPlans', component: () => import('../views/IrrigationPlans.vue') },
  // 泵房：/headPump（设备详情页正在开发中）
  { path: '/headPump', name: 'headPump', component: () => import('../views/HeadPump.vue') },
  // 卷帘机：/headRollCurtain（设备详情页正在开发中）
  { path: '/headRollCurtain', name: 'headRollCurtain', component: () => import('../views/HeadRollCurtain.vue') },
  // 闸门：/headGate（设备详情页正在开发中）
  { path: '/headGate', name: 'headGate', component: () => import('../views/HeadGate.vue') },
  // 网关：/headGateway（设备详情页正在开发中）
  { path: '/headGateway', name: 'headGateway', component: () => import('../views/HeadGateway.vue') },
  // 施肥罐：/headFertilizationTank（设备详情页正在开发中）
  { path: '/headFertilizationTank', name: 'headFertilizationTank', component: () => import('../views/HeadFertilizationTank.vue') },
  // U680 ：/headU680（支持 27、25、09）
  { path: '/headU680', name: 'headU680', component: () => import('../views/HeadU680.vue') },
  // 施肥机：/headFertilizerMachine（type=100 详情，其他类型开发中）
  { path: '/headFertilizerMachine', name: 'headFertilizerMachine', component: () => import('../views/HeadFertilizerMachine.vue') },
  // 控制柜：/headControlCabinet
  { path: '/headControlCabinet', name: 'headControlCabinet', component: () => import('../views/HeadControlCabinet.vue') },
  // 长虹墒情站：/changhongSoilMoisture（设备详情页正在开发中）
  { path: '/changhongSoilMoisture', name: 'changhongSoilMoisture', component: () => import('../views/ChanghongSoilMoisture.vue') },
  // 长虹气象站：/changhongWeatherStation（设备详情页正在开发中）
  { path: '/changhongWeatherStation', name: 'changhongWeatherStation', component: () => import('../views/ChanghongWeatherStation.vue') },
  // 优联温室传感器：/greenhouseSensor（设备详情页正在开发中）
  { path: '/greenhouseSensor', name: 'greenhouseSensor', component: () => import('../views/GreenhouseSensor.vue') },
  // 及时雨虫情站：/jishiyuInsectStation（设备详情页正在开发中）
  { path: '/jishiyuInsectStation', name: 'jishiyuInsectStation', component: () => import('../views/JishiyuInsectStation.vue') },
  // 任科虫情站：/renkeInsectStation（设备详情页正在开发中）
  { path: '/renkeInsectStation', name: 'renkeInsectStation', component: () => import('../views/RenkeInsectStation.vue') },
  // 优联环境监测传感器：/environmentSensor（设备详情页正在开发中）
  { path: '/environmentSensor', name: 'environmentSensor', component: () => import('../views/EnvironmentSensor.vue') },
  // 优联水质监测仪：/waterQuality（设备详情页正在开发中）
  { path: '/waterQuality', name: 'waterQuality', component: () => import('../views/WaterQuality.vue') },
  // 及时雨孢子仪：/sporeCollector（设备详情页正在开发中）
  { path: '/sporeCollector', name: 'sporeCollector', component: () => import('../views/SporeCollector.vue') },
  // 第三方杀虫灯：/thirdPartyInsecticidalLamp（设备详情页正在开发中）
  { path: '/thirdPartyInsecticidalLamp', name: 'thirdPartyInsecticidalLamp', component: () => import('../views/ThirdPartyInsecticidalLamp.vue') },
  // 长虹杀虫灯：/changhongInsecticidalLamp（设备详情页正在开发中）
  { path: '/changhongInsecticidalLamp', name: 'changhongInsecticidalLamp', component: () => import('../views/ChanghongInsecticidalLamp.vue') },
  // 优联积温积光仪：/accumulatedTemperatureLight（设备详情页正在开发中）
  { path: '/accumulatedTemperatureLight', name: 'accumulatedTemperatureLight', component: () => import('../views/AccumulatedTemperatureLight.vue') },
  // 温湿度采集器：/temperatureHumidity
  { path: '/temperatureHumidity', name: 'temperatureHumidity', component: () => import('../views/TemperatureHumidity.vue') },
  // 虫情站：/insectStation
  { path: '/insectStation', name: 'insectStation', component: () => import('../views/InsectStation.vue') },
  // 气象站：/weatherStation
  {
    path: '/weatherStation',
    name: 'weatherStation',
    component: () => import('../views/WeatherStation.vue')
  },
  // 杀虫灯：/insecticidalLamp
  {
    path: '/insecticidalLamp',
    name: 'insecticidalLamp',
    component: () => import('../views/InsecticidalLamp.vue')
  },
  // 墒情站：/soilMoisture
  {
    path: '/soilMoisture',
    name: 'soilMoisture',
    component: () => import('../views/SoilMoisture.vue')
  },
  // 设备控制（出地桩及关联设备）：/equipment
  {
    path: '/equipment',
    name: 'equipment',
    component: () => import('../views/Equipment.vue')
  },
  // 视频监控 / 录像回放：/ezplay
  {
    path: '/ezplay',
    name: 'ezplay',
    component: () => import('../views/Ezplay.vue')
  },
  // 农场运行状态：/farmRunningStatus
  {
    path: '/farmRunningStatus',
    name: 'farmRunningStatus',
    component: () => import('../views/FarmRunningStatus.vue')
  },
  // 水肥方案：/waterFertilizerScheme
  {
    path: '/waterFertilizerScheme',
    name: 'waterFertilizerScheme',
    component: () => import('../views/WaterFertilizerScheme.vue')
  },
  // 地块边界编辑：/landEdit?farmId=...&landId=...
  { path: '/landEdit', name: 'landEdit', component: () => import('../views/LandEdit.vue') },
  // 调度中心：/dispatchCenter
  {
    path: '/dispatchCenter',
    name: 'dispatchCenter',
    component: () => import('../views/DispatchCenter.vue')
  },
  // 用户管理：/users
  {
    path: '/users',
    name: 'users',
    component: () => import('../views/Users.vue')
  },
  // 设备状态：/deviceStatus
  {
    path: '/deviceStatus',
    name: 'deviceStatus',
    component: () => import('../views/DeviceStatus.vue')
  },
  // 巡检记录：/patrolRecords
  {
    path: '/patrolRecords',
    name: 'patrolRecords',
    component: () => import('../views/RecordList.vue'),
    props: { recordType: 'patrol' }
  },
  // 农事记录：/farmingRecords
  {
    path: '/farmingRecords',
    name: 'farmingRecords',
    component: () => import('../views/RecordList.vue'),
    props: { recordType: 'farming' }
  },
  // {
  //   path: '/Ylsfj',
  //   name: 'Ylsfj',
  //   component: Ylsfj
  // },
  // {
  //   path: '/Ylsfj2',
  //   name: 'Ylsfj2',
  //   component: Ylsfj2
  // },
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// Carry the explicit browser marker or legacy native platform on internal navigation.
for (const method of ['push', 'replace']) {
  const navigate = router[method].bind(router)
  router[method] = (location, onComplete, onAbort) => {
    if (webAuth.browser) {
      const resolved = router.resolve(location).route
      const query = { ...resolved.query }
      if (!Object.prototype.hasOwnProperty.call(query, 'webApp')) query.webApp = '1'
      if (!Object.prototype.hasOwnProperty.call(query, 'appFontSize')) query.appFontSize = ({ '0.85': 'small', '1': 'standard', '1.15': 'large', '1.3': 'extraLarge' })[appFont.scale] || 'standard'
      location = { path: resolved.path, query, hash: resolved.hash }
    } else if (webAuth.platform) {
      const resolved = router.resolve(location).route
      if (!Object.prototype.hasOwnProperty.call(resolved.query, 'os')) {
        location = { path: resolved.path, query: { ...resolved.query, os: webAuth.platform }, hash: resolved.hash }
      }
    }
    return navigate(location, onComplete, onAbort)
  }
}

let verified = false
router.beforeEach(async (to, from, next) => {
  const platform = platformFromQuery(to.query, webAuth.platform)
  // Canonicalize only dedicated web entry routes, never legacy business URLs.
  if (isWebEntry(to.path) && !platform && !Object.prototype.hasOwnProperty.call(to.query, 'webApp')) return next({ path: to.path, query: { ...to.query, webApp: '1' }, hash: to.hash, replace: true })
  const browser = isWebAppQuery(to.query)
  if (platform !== webAuth.platform || browser !== webAuth.browser) {
    verified = false
    webAuth.platform = platform
    webAuth.browser = browser
    webAuth.expired = false
    webAuth.revision++
  }
  if (!browser) return next()
  if (to.path === '/login') return next()
  const login = reason => ({ path: '/login', query: { webApp: '1', redirect: to.fullPath, ...(Object.prototype.hasOwnProperty.call(to.query, 'appFontSize') ? { appFontSize: to.query.appFontSize } : {}), ...(reason ? { reason } : {}) }, replace: true })
  if (!webAuth.session) { verified = false; return next(login()) }
  if (!verified) {
    const revision = webAuth.revision
    try {
      const profile = await checkWebSession()
      if (revision !== webAuth.revision) return next(false)
      saveWebSession({ ...webAuth.session, profile })
      verified = true
    } catch (error) {
      if (revision !== webAuth.revision) return next(false)
      if (error.sessionExpired) saveWebSession(null)
      return next(login(error.sessionExpired ? 'expired' : 'unavailable'))
    }
  }
  if (webEntries.some(entry => entry.path === to.path) && (typeof to.query.farmId !== 'string' || !to.query.farmId.trim())) {
    return next({ path: '/web/home', query: { webApp: '1', ...(Object.prototype.hasOwnProperty.call(to.query, 'appFontSize') ? { appFontSize: to.query.appFontSize } : {}) }, replace: true })
  }
  next()
})
window.addEventListener('eelink-web-session-expired', () => {
  verified = false
  if (!webAuth.browser || router.currentRoute.path === '/login') return
  router.replace({ path: '/login', query: { webApp: '1', reason: 'expired', redirect: router.currentRoute.fullPath } }).catch(() => {})
})

router.afterEach(to => {
  if (isWebAppQuery(to.query)) document.title = webPageTitle(to)
})

export default router
